import "./mspAttackSurface.scss";
import "./technologySpendFilter/technologyFilters.scss";
import {
  addDays,
  startOfDay,
  startOfMonth,
  subMonths,
} from "../../../utils/date-fns-replacement";

export function convertToDDMMYYYY(formattedDate) {
  const dateObject = new Date(formattedDate);
  const day = dateObject.getDate();
  const month = dateObject.getMonth() + 1; // Month is 0-based, so add 1
  const year = dateObject.getFullYear();

  const formattedDateString = `${day.toString().padStart(2, "0")}/${month
    .toString()
    .padStart(2, "0")}/${year}`;
  return formattedDateString;
}

export function getListViewFilters(kwargs) {
  let criterion_filters = [];
  if (kwargs?.filters) {
    for (let index = 0; index < kwargs?.filters?.length; index++) {
      if (
        kwargs?.filters[index]?.filterType === "supplier" &&
        kwargs?.filters[index]?.filterList?.length > 0
      ) {
        criterion_filters.push({
          criteriaEnum: 0,
          SearchParams: kwargs?.filters[index]?.filterList?.map(
            (item) => item?.PotentialSupplierId.toString()
          ),
        });
      }
      if (
        kwargs?.filters[index]?.filterType === "date" &&
        kwargs?.filters[index]?.selectedDateRange?.startDate &&
        kwargs?.filters[index]?.selectedDateRange?.endDate
      ) {
        criterion_filters.push({
          criteriaEnum: 1,
          SearchParams: [
            kwargs?.filters[index]?.selectedDateRange?.startDate,
            kwargs?.filters[index]?.selectedDateRange?.endDate,
          ],
        });
      }
      if (
        kwargs?.filters[index]?.filterType === "category" &&
        kwargs?.filters[index]?.filterList?.length > 0
      ) {
        criterion_filters.push({
          criteriaEnum: 2,
          SearchParams: kwargs?.filters[index]?.filterList?.map(
            (item) => item.CategoryID.toString()
          ),
        });
      }
      if (
        kwargs?.filters[index]?.filterType === "subcategory" &&
        kwargs?.filters[index]?.filterList?.length > 0
      ) {
        criterion_filters.push({
          criteriaEnum: 3,
          SearchParams: kwargs?.filters[index]?.filterList?.map(
            (item) => item.CategoryID.toString()
          ),
        });
      }
      if (
        kwargs?.filters[index]?.filterType === "amount" &&
        kwargs?.filters[index]?.toAmount &&
        kwargs?.filters[index]?.fromAmount
      ) {
        criterion_filters.push({
          criteriaEnum: 4,
          SearchParams:kwargs?.filters[index]?.toAmount? [
            kwargs?.filters[index]?.fromAmount.toString(),
            kwargs?.filters[index]?.toAmount.toString(),
          ]:[
            kwargs?.filters[index]?.fromAmount.toString(), 
          ],
        });
      }
      if (
        kwargs?.filters[index]?.filterType === "status" &&
        kwargs?.filters[index]?.filterList?.length > 0
      ) {
        criterion_filters.push({
          criteriaEnum: 5,
          SearchParams: kwargs?.filters[index]?.filterList?.map(
            (item) => item.Id.toString()
          ),
        });
      }
      if (
        kwargs?.filters[index]?.filterType === "expires" &&
        kwargs?.filters[index]?.selectedDateRange?.startDate &&
        kwargs?.filters[index]?.selectedDateRange?.endDate
      ) {
        criterion_filters.push({
          criteriaEnum: 6,
          SearchParams: [
            kwargs?.filters[index]?.selectedDateRange?.startDate,
            kwargs?.filters[index]?.selectedDateRange?.endDate,
          ],
        });
      }
    }
  }

  return criterion_filters;
}



export function getDateDifferenceCategory(date1, date2) {
  // Convert the input strings to Date objects
  const startDate = new Date(date1);
  const endDate = new Date(date2);

  // Calculate the time difference in milliseconds
  const timeDifference = endDate - startDate;

  // Get the current date
  const currentDate = new Date();
  currentDate.setHours(23, 59, 59, 0);

  // Define the time frames
  const currentYearStart = new Date(currentDate.getFullYear(), 0, 1);

  const last12MonthsStart = startOfMonth(subMonths(new Date(), 12));
  const previousYearStart = new Date(currentDate.getFullYear() - 1, 0, 1);
  const previousYearEnd = new Date(currentDate.getFullYear() - 1, 11, 31);
  previousYearEnd.setHours(23, 59, 59);
  const last6MonthsStart = startOfMonth(subMonths(new Date(), 6));
  const last90DaysStart = startOfDay(addDays(new Date(), -90));
  const last30DaysStart = startOfDay(addDays(new Date(), -30));

  // Compare the input dates with the defined time frames
  if (
    startDate.getTime() === currentYearStart.getTime() &&
    isDifferenceInRange(endDate.getTime(), currentDate.getTime(), 5000)
  ) {
    return "Current Year";
  } else if (
    startDate.getTime() === previousYearStart.getTime() &&
    isDifferenceInRange(endDate.getTime(), previousYearEnd.getTime(), 5000)
  ) {
    return "Previous Year";
  } else if (
    startDate.getTime() === last12MonthsStart.getTime() &&
    isDifferenceInRange(endDate.getTime(), currentDate.getTime(), 5000)
  ) {
    return "Last 12 Months";
  } else if (
    startDate.getTime() === last6MonthsStart.getTime() &&
    isDifferenceInRange(endDate.getTime(), currentDate.getTime(), 5000)
  ) {
    return "Last 6 Months";
  } else if (
    startDate.getTime() === last90DaysStart.getTime() &&
    isDifferenceInRange(endDate.getTime(), currentDate.getTime(), 5000)
  ) {
    return "Last 90 Days";
  } else if (
    startDate.getTime() === last30DaysStart.getTime() &&
    isDifferenceInRange(endDate.getTime(), currentDate.getTime(), 5000)
  ) {
    return "Last 30 Days";
  } else {
    const options = { year: "numeric", month: "short", day: "numeric" };
    const _startDate = startDate.toLocaleDateString("en-US", options);
    const _endDate = endDate.toLocaleDateString("en-US", options);
    return _startDate + " - " + _endDate;
  }
}

function isDifferenceInRange(number1, number2, difference) {
  const absoluteDifference = Math.abs(number1 - number2);
  return absoluteDifference <= difference;
}